import React from 'react';
import { FormattedMessage } from 'react-intl';

interface AddressProps {
    street?: string;
    city?: string;
    zip?: string;
    countryCode?: string;
    showLabel?: boolean;
}

const Address: React.FC<AddressProps> = ({ street, city, zip, countryCode, showLabel = false }) => {
    return (
        <>
            {showLabel && (
                <div className={'text-color-gray margin-top-10'}>
                    <FormattedMessage id={'intl-msg:vehicle-diagnostics.dialog.address'} />
                </div>
            )}
            {renderText(street)}
            {zip && city ? `${zip.trim()} ${city.trim()}` : renderText(city)}
            {countryCode && (
                <div>
                    <FormattedMessage id={`intl-msg:common.country.${countryCode}`} defaultMessage={countryCode} />
                </div>
            )}
        </>
    );
};

const renderText = (text?: string) => {
    return text ? <div>{text.trim()}</div> : '-';
};

export default Address;
